import { render } from "./WalletHistoryDetail.vue?vue&type=template&id=218cce00"
import script from "./WalletHistoryDetail.vue?vue&type=script&lang=js"
export * from "./WalletHistoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__